import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppUser } from '../../utilities/interfaces/AppUser';
import { appUserAPI } from '../../utilities/api/appUserApi';
import { AppUserRole } from '../../utilities/interfaces/AppUserRole';
import { Role } from '../../utilities/interfaces/Role';

interface AppUserState {
  appUser: AppUser | null;
  appUsers: AppUser[];
  appUserCurrentRoles: Role[];
  appUserCurrentTitles: any;
  appUserAvailableRoles: Role[];
  appUserAvailableAgencies: any;
  allRoles: Role[];
  error: string | null;
  fetchingAppUsers: boolean;
}

const initialState: AppUserState = {
  appUser: null,
  appUsers: [],
  appUserCurrentRoles: [],
  appUserAvailableRoles: [],
  error: null,
  allRoles: [],
  appUserCurrentTitles: null,
  appUserAvailableAgencies: null,
  fetchingAppUsers: false,
};

const appUserSlice = createSlice({
  name: 'stateAppUser',
  initialState,
  reducers: {
    clearRoles(state) {
      state.appUserCurrentRoles = [];
      state.appUserAvailableRoles = [];
    },
    addTitles(state, payload) {
      state.appUserCurrentTitles = payload
    },
    addAgencies(state, payload) {
      state.appUserAvailableAgencies = payload
    }
  },
  extraReducers(builder) {
    builder.addCase(getAllAppUsers.pending, (state) => {
      state.fetchingAppUsers = true;
    })
    builder.addCase(getAllAppUsers.fulfilled, (state, action) => {
      state.appUsers = action.payload;
      state.fetchingAppUsers = false;
    });
    builder.addCase(getAllAppUsers.rejected, (state) => {
      state.fetchingAppUsers = false;
    })
    // builder.addCase(createAppUser.fulfilled,(state,action: any)=>{
    //   state.appUsers.push(action.payload);
    // });
    // builder.addCase(updateAppUser.fulfilled, (state, action:any)=>{
    //   // find app user in redux store and update
    //   var index = state.appUsers.findIndex((x) => (x.id = action.payload.id));
    //   state.appUsers[index] = action.payload;
    // });
    builder.addCase(getAppUserById.fulfilled, (state, action) => {
      state.appUser = action.payload;
    });

    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      state.allRoles = action.payload;
    });

    builder.addCase(getCurrentRolesForAppUser.fulfilled, (state, action: any) => {
      const currentRoles = action.payload;

      state.appUserCurrentRoles = currentRoles;
      state.appUserAvailableRoles = state.allRoles.filter((a) => !currentRoles.find((c: Role) => c.id === a.id));
    });
    builder.addCase(createAppUserRole.fulfilled, (state, action: any) => {
      let newRole: Role = {
        id: action.payload.id,
        name: action.payload.name,
      };

      state.appUserCurrentRoles.push(newRole);
      state.appUserAvailableRoles = state.appUserAvailableRoles.filter((x) => x.id !== newRole.id);
    });
    builder.addCase(deleteAppUserRole.fulfilled, (state, action: any) => {
      let newRole: Role = {
        id: action.payload.id,
        name: action.payload.name,
      };

      state.appUserAvailableRoles.push(newRole);
      state.appUserCurrentRoles = state.appUserCurrentRoles.filter((x) => x.id !== newRole.id);
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getAllAppUsers = createAsyncThunk('stateAppUser/getAllAppUsers', async () => {
  return await appUserAPI.getAllAppUsers();
});

// export const createAppUser = createAsyncThunk('stateAppUser/createAppUser', async (appUser: AppUser) =>{
//   const response = await appUserAPI.createAppUser(appUser);
//   return response;
// });

export const createAppUserRole = createAsyncThunk(
  'stateAppUser/createAppUserRole',
  async (appUserRole: AppUserRole) => {
    return await appUserAPI.createAppUserRole(appUserRole.appUserId!, appUserRole.roleName);
  }
);

export const deleteAppUserRole = createAsyncThunk(
  'stateAppUser/deleteAppUserRole',
  async (appUserRole: AppUserRole) => {
    return await appUserAPI.deleteAppUserRole(appUserRole.appUserId!, appUserRole.roleName);
  }
);

export const getCurrentRolesForAppUser = createAsyncThunk(
  'stateAppUser/getCurrentRolesForAppUser',
  async (id: string) => {
    return await appUserAPI.getRolesForAppUser(id);
  }
);

export const getAllRoles = createAsyncThunk('stateAppUser/getAllRoles', async () => {
  return await appUserAPI.getAllRoles();
});

// export const updateAppUser = createAsyncThunk('stateAppUser/updateAppUser', async (appUser: AppUser) => {
//   const response = await appUserAPI.updateAppUser(appUser);
//   return response;
// });

export const getAppUserById = createAsyncThunk(
  'stateAppUser/getAppUserById',
  async (id: string) => {
    return await appUserAPI.getAppUserById(id);
  }
);


export const { clearRoles, addTitles, addAgencies } = appUserSlice.actions;
export default appUserSlice.reducer;
